import { Routes } from '@angular/router';
import { DrDrevSaisieComponent } from './dr-drev-saisie.component';

export const DR_DREV_SAISIES_ROUTES: Routes = DrDrevSaisieComponent.routes;
